export const SupplierQuestionaryFormIcon = ({ fill = '#4D5E93' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path
            d="M11.5663 11.8753C12.4775 12.7865 12.4775 14.2639 11.5663 15.1751C10.655 16.0864 9.17765 16.0864 8.26643 15.1751C7.3552 14.2639 7.3552 12.7865 8.26643 11.8753C9.17765 10.9641 10.655 10.9641 11.5663 11.8753"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M17.5 12.8333H22.1667"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M21 16.9168H17.5" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M13.9997 21.0481C13.8013 20.5499 13.4945 20.1019 13.1002 19.7367V19.7367C12.434 19.1196 11.559 18.7754 10.6502 18.7754H9.18251C8.27367 18.7754 7.39867 19.1184 6.73251 19.7367V19.7367C6.33817 20.1007 6.03134 20.5487 5.83301 21.0481"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.167 8.16683H12.8337C12.1897 8.16683 11.667 7.64416 11.667 7.00016V3.50016C11.667 2.85616 12.1897 2.3335 12.8337 2.3335H15.167C15.811 2.3335 16.3337 2.85616 16.3337 3.50016V7.00016C16.3337 7.64416 15.811 8.16683 15.167 8.16683Z"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.6663 5.8335H4.71417C3.39934 5.8335 2.33301 6.89983 2.33301 8.21466V22.1668C2.33301 23.456 3.37717 24.5002 4.66634 24.5002H23.333C24.6222 24.5002 25.6663 23.456 25.6663 22.1668V8.16683C25.6663 6.87766 24.6222 5.8335 23.333 5.8335H16.333"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
